import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  FrameType_BINARY_getInstance322fv5umlaak0 as FrameType_BINARY_getInstance,
  FrameType_TEXT_getInstancegx0aih9zi595 as FrameType_TEXT_getInstance,
  FrameType_CLOSE_getInstance18b0xemwe4t20 as FrameType_CLOSE_getInstance,
  FrameType_PING_getInstance3qbqh4hk4xba as FrameType_PING_getInstance,
  FrameType_PONG_getInstanceql6atakcop4o as FrameType_PONG_getInstance,
} from './FrameType.mjs';
import { NonDisposableHandle_instance3amt6bvd9jgby as NonDisposableHandle_instance } from './FrameCommon.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  toByteArray1i3ns5jnoqlv6 as toByteArray,
  writeText19qfzm98fbm4l as writeText,
} from '../../../../ktor-ktor-io/io/ktor/utils/io/core/Strings.mjs';
import { Buffergs925ekssbch as Buffer } from '../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Buffer.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { readByteArray1ri21h2rciakw as readByteArray } from '../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Sources.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { createThis2j2avj17cvnv2 as createThis } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var BinaryClass;
function Binary() {
  if (BinaryClass === VOID) {
    class $ extends Frame() {
      static v5j(fin, data, rsv1, rsv2, rsv3) {
        rsv1 = rsv1 === VOID ? false : rsv1;
        rsv2 = rsv2 === VOID ? false : rsv2;
        rsv3 = rsv3 === VOID ? false : rsv3;
        return this.w5j(fin, FrameType_BINARY_getInstance(), data, NonDisposableHandle_instance, rsv1, rsv2, rsv3);
      }
      static x5j(fin, data) {
        return this.v5j(fin, data, false, false, false);
      }
    }
    initMetadataForClass($, 'Binary');
    BinaryClass = $;
  }
  return BinaryClass;
}
var TextClass;
function Text() {
  if (TextClass === VOID) {
    class $ extends Frame() {
      static f5k(fin, data, rsv1, rsv2, rsv3) {
        rsv1 = rsv1 === VOID ? false : rsv1;
        rsv2 = rsv2 === VOID ? false : rsv2;
        rsv3 = rsv3 === VOID ? false : rsv3;
        return this.w5j(fin, FrameType_TEXT_getInstance(), data, NonDisposableHandle_instance, rsv1, rsv2, rsv3);
      }
      static g5k(fin, data) {
        return this.f5k(fin, data, false, false, false);
      }
      static h5k(text) {
        return this.g5k(true, toByteArray(text));
      }
    }
    initMetadataForClass($, 'Text');
    TextClass = $;
  }
  return TextClass;
}
var CloseClass;
function Close() {
  if (CloseClass === VOID) {
    class $ extends Frame() {
      static i5k(data) {
        return this.w5j(true, FrameType_CLOSE_getInstance(), data, NonDisposableHandle_instance, false, false, false);
      }
      static n5g(reason) {
        // Inline function 'io.ktor.utils.io.core.buildPacket' call
        var builder = new (Buffer())();
        builder.x4k(reason.e5f_1);
        writeText(builder, reason.f5f_1);
        return this.j5k(builder);
      }
      static j5k(packet) {
        return this.i5k(readByteArray(packet));
      }
      static k5k() {
        return this.i5k(Companion_getInstance().q5h_1);
      }
    }
    initMetadataForClass($, 'Close', $.k5k);
    CloseClass = $;
  }
  return CloseClass;
}
var PingClass;
function Ping() {
  if (PingClass === VOID) {
    class $ extends Frame() {
      static o5i(data) {
        return this.w5j(true, FrameType_PING_getInstance(), data, NonDisposableHandle_instance, false, false, false);
      }
    }
    initMetadataForClass($, 'Ping');
    PingClass = $;
  }
  return PingClass;
}
var PongClass;
function Pong() {
  if (PongClass === VOID) {
    class $ extends Frame() {
      static k5h(data, disposableHandle) {
        disposableHandle = disposableHandle === VOID ? NonDisposableHandle_instance : disposableHandle;
        return this.w5j(true, FrameType_PONG_getInstance(), data, disposableHandle, false, false, false);
      }
    }
    initMetadataForClass($, 'Pong');
    PongClass = $;
  }
  return PongClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.q5h_1 = new Int8Array(0);
      }
      r5h(fin, frameType, data, rsv1, rsv2, rsv3) {
        var tmp;
        switch (frameType.w1_1) {
          case 1:
            tmp = Binary().v5j(fin, data, rsv1, rsv2, rsv3);
            break;
          case 0:
            tmp = Text().f5k(fin, data, rsv1, rsv2, rsv3);
            break;
          case 2:
            tmp = Close().i5k(data);
            break;
          case 3:
            tmp = Ping().o5i(data);
            break;
          case 4:
            tmp = Pong().k5h(data, NonDisposableHandle_instance);
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        return tmp;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var FrameClass;
function Frame() {
  if (FrameClass === VOID) {
    class $ {
      static w5j(fin, frameType, data, disposableHandle, rsv1, rsv2, rsv3) {
        Companion_getInstance();
        disposableHandle = disposableHandle === VOID ? NonDisposableHandle_instance : disposableHandle;
        rsv1 = rsv1 === VOID ? false : rsv1;
        rsv2 = rsv2 === VOID ? false : rsv2;
        rsv3 = rsv3 === VOID ? false : rsv3;
        var $this = createThis(this);
        $this.p5g_1 = fin;
        $this.q5g_1 = frameType;
        $this.r5g_1 = data;
        $this.s5g_1 = disposableHandle;
        $this.t5g_1 = rsv1;
        $this.u5g_1 = rsv2;
        $this.v5g_1 = rsv3;
        return $this;
      }
      toString() {
        return 'Frame ' + this.q5g_1.toString() + ' (fin=' + this.p5g_1 + ', buffer len = ' + this.r5g_1.length + ')';
      }
    }
    initMetadataForClass($, 'Frame');
    FrameClass = $;
  }
  return FrameClass;
}
//region block: exports
export {
  Companion_getInstance as Companion_getInstance13o6h9kfs12i5,
  Binary as Binary3tlzyfojm51s4,
  Close as Close3tx65evcwi73t,
  Ping as Ping3nta6l7sdq1r9,
  Pong as Pong3m3cas9hmc9ec,
  Text as Text3e6ukp9joohql,
};
//endregion

//# sourceMappingURL=Frame.web.mjs.map
